import {
  StyledTitle,
  StyledContainer,
  StyledEmptyMessageContainer,
  StyledEmptyText,
  StyledHeaderEmpty,
  StyledTopContainerEmpty,
  StyledEmptyIcon
} from '@/containers/SubscriptionFormPageNew/Components/LegacyRightPanel/Distributor/styled-components'

import IconLocationCompany from '@/shared/icons/NewDesign/IconLocationCompany'
import useDistributor from '@/containers/SubscriptionFormPageNew/Components/Distributor/useDistributor'
import DistributorEmptyMessage
  from '@/containers/SubscriptionFormPageNew/Components/Distributor/DistributorEmptyMessage'

const DistributorEmpty = () => {
  const { t, address } = useDistributor();
  return (
    <StyledContainer>
      <StyledTopContainerEmpty>
        <StyledHeaderEmpty>
          <StyledTitle>{t('subscriptionForm:distributor.title')}</StyledTitle>
        </StyledHeaderEmpty>
      </StyledTopContainerEmpty>
      <StyledEmptyMessageContainer>
        <StyledEmptyIcon>
          <IconLocationCompany size={60} color="#A9ABAE" />
        </StyledEmptyIcon>
        <StyledEmptyText>
          <DistributorEmptyMessage address={address} />
        </StyledEmptyText>
      </StyledEmptyMessageContainer>
    </StyledContainer>
  );
}

export default DistributorEmpty;
